import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { JwtToken } from '../models/token.model';
import { TokenService } from './token.service';

export let API_ENDPOINT: string;

export let ENDPOINTS = {
    USER: 'user/me',
    CHANGE_PASS: 'user/me/change-pass',
    REGISTER: 'user/register',
    TOKEN: 'user/token',
    USER_CONFIG: 'tts/user-config',
    EXECUTION: 'tts/execution',
};

@Injectable()
export class BaseHttpService {
    protected authorizedRequestOptions = {
        headers: new HttpHeaders({ Authorization: '' }),
        // withCredentials: true,
    };

    constructor(protected tokenService: TokenService) {
        API_ENDPOINT = `${environment.BACKEND_URL}/api`;
        this.tokenService.getToken().subscribe((token: JwtToken) => {
            if (token) {
                this.authorizedRequestOptions.headers = new HttpHeaders({
                    Authorization: `Bearer ${token.access}`,
                });
            }
        });
    }
}
